import React from "react";
import { GoDot } from "react-icons/go";

const QuestionnaireGuidelines = () => {
  return (
    <div className="font-jost h-full  w-full  ">
      <div className="flex w-full flex-col text-justify">
        <div>
          <h1 className="p-2 text-center text-4xl">Questionnaire Guidelines</h1>
        </div>
        <div className="flex w-full flex-col items-start justify-center gap-3  px-5 py-3">
          <div className="flex flex-col gap-3">
            <h1 className="text-18px font-semibold">Purpose</h1>
            <ul className="flex list-disc flex-col gap-2 px-2 text-justify sm:px-10">
              <li>
                This questionnaire is designed to help you reflect on yourself
                and allow your prospective partner to get to know you better{" "}
                <span className="font-semibold">before meeting in person.</span>
              </li>
              <li>
                It serves as a{" "}
                <span className="font-semibold">starting point</span> for
                deeper, meaningful conversations.
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-3">
            <h1 className="text-18px font-semibold">How to Answer:</h1>
            <ul className="flex list-disc flex-col gap-2 px-2 text-justify sm:px-10">
              <li>
                <span className="font-semibold">Be honest and sincere.</span>{" "}
                This is not about giving the “best” answers—it’s about sharing
                your true thoughts and beliefs.
              </li>
              <li>
                <span className="font-semibold">
                  Don’t try to impress anyone.
                </span>{" "}
                Authenticity is key.
              </li>
              <li>
                <span className="font-semibold">
                  {" "}
                  Answer the questions yourself.
                </span>{" "}
                Friends or family should not fill this out on your behalf.
              </li>
              <li>
                <span className="font-semibold">Think carefully</span> about
                each question and give it your full attention
              </li>
              <li>
                <span className="font-semibold">Follow the instructions</span>{" "}
                for each question format (e.g., multiple-choice, rating scale,
                open-ended).
              </li>
            </ul>
          </div>
          <div className="flex flex-col gap-3">
            <h1 className="text-18px font-semibold">
              Tips for Completing the Questionnaire:
            </h1>
            <div className="px-2 sm:px-5">
              <div className="flex items-center gap-1">
                <GoDot />
                <h1 className="text-16px font-semibold">
                  Give clear and complete answers
                </h1>
              </div>

              <ul className="flex list-disc flex-col gap-2 px-4  sm:px-12">
                <li>
                  For multiple-choice or rating questions: Select the option
                  that best reflects your view.
                </li>
              </ul>
            </div>
            <div className="px-2 sm:px-5">
              <div className="flex items-center gap-1">
                <GoDot />
                <h1 className="text-16px font-semibold">
                  It’s okay if you don’t have all the answers
                </h1>
              </div>

              <ul className="flex list-disc flex-col gap-2 px-4  sm:px-12">
                <li>
                  You may respond with: “I don’t know,” “I haven’t thought about
                  this,” “I’m not interested in this topic,” or “I prefer to
                  discuss this in person.” Or any other such answer{" "}
                </li>
              </ul>
            </div>
            <div className="flex items-center gap-1 px-2 sm:px-5">
              <GoDot />
              <p>
                <span className="font-semibold">
                  Aim to answer all questions
                </span>{" "}
                if possible, as this gives a fuller picture of who you are.
              </p>
            </div>
            <div className="flex items-center gap-1 px-2 sm:px-5">
              <GoDot />
              <p>
                <span className="font-semibold">Take breaks if needed.</span>{" "}
                Your progress will be saved on the website.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <h1 className="text-18px font-semibold">Privacy and Respect</h1>
            <ul className="flex list-disc flex-col gap-2 px-2 sm:px-10">
              <li>
                Your completed questionnaire will only be shared with a
                candidate{" "}
                <span className="font-semibold">with your consent.</span>
              </li>
              <li>
                When sharing or receiving questionnaires,{" "}
                <span className="font-semibold">
                  respect the other person’s privacy.
                </span>{" "}
                Do not share their responses with anyone else
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireGuidelines;
